import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";

export default function NewsDetail() {
  const { id } = useParams();
  const [art, setArt] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/news/${id}`);
        setArt(data);
        if (data.category_slug) {
          const r = await api.get(`/news?category=${data.category_slug}&limit=4`);
          setRelated(r.data.filter((x) => x.id !== id).slice(0, 3));
        }
      } finally { setLoading(false); }
    })();
  }, [id]);

  if (loading) return <div className="pt-32 text-center text-zinc-500">Loading...</div>;
  if (!art) return <div className="pt-32 text-center text-zinc-500">Article not found.</div>;

  return (
    <div className="pt-24 pb-20" data-testid="news-detail">
      {art.image_url && (
        <div className="relative h-[420px] md:h-[560px] w-full overflow-hidden">
          <img src={art.image_url} alt={art.title} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent" />
        </div>
      )}
      <article className="max-w-3xl mx-auto px-6 -mt-32 relative z-10">
        <span className="inline-block px-3 py-1 text-xs font-mono uppercase tracking-[0.2em] bg-yellow-400 text-black">
          {art.category_slug?.replace("-", " ") || "News"}
        </span>
        <h1 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl text-white tracking-tighter mt-6 leading-[1.05]">
          {art.title}
        </h1>
        <div className="mt-6 flex items-center gap-3 text-sm font-mono text-zinc-400">
          <span>{art.author_name}</span>
          <span>•</span>
          <span>{new Date(art.created_at).toLocaleDateString()}</span>
          <span>•</span>
          <span>{art.views || 0} views</span>
        </div>
        {art.excerpt && (
          <p className="mt-8 text-xl text-zinc-300 leading-relaxed font-medium border-l-2 border-yellow-400 pl-6">
            {art.excerpt}
          </p>
        )}
        <div className="prose-hashrate mt-10">
          {art.content.split("\n\n").map((p, i) => <p key={i}>{p}</p>)}
        </div>
        {art.tags?.length > 0 && (
          <div className="mt-10 flex flex-wrap gap-2">
            {art.tags.map((t) => (
              <span key={t} className="px-3 py-1 bg-white/5 border border-white/10 text-xs font-mono uppercase text-zinc-300">
                #{t}
              </span>
            ))}
          </div>
        )}
      </article>

      {related.length > 0 && (
        <section className="max-w-[1400px] mx-auto px-6 md:px-10 mt-20">
          <h3 className="font-display font-bold text-2xl text-white border-b border-white/10 pb-4 mb-8">
            <span className="text-yellow-400">/</span> Related stories
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {related.map((r) => (
              <Link key={r.id} to={`/news/${r.id}`} className="block bg-[#0a0a0b] border border-white/10 hover:border-yellow-400/40 transition p-5">
                <h4 className="font-display font-bold text-lg text-white">{r.title}</h4>
                <p className="mt-2 text-sm text-zinc-400 line-clamp-2">{r.excerpt}</p>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
